module.exports = __webpack_public_path__ + "img/1.c49f1400.jpg";